import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LangContext";
import { MultiLangField } from "@/components/admin/Fields";

const FIELDS = ["bank_name", "account_name", "account_number"];

export const PaymentSettings = ({ draft, set }) => {
  const { t } = useLang();
  const accounts = draft.bank_accounts || [];
  const update = (i, k, v) => set("bank_accounts", accounts.map((a, idx) => (idx === i ? { ...a, [k]: v } : a)));
  const add = () => set("bank_accounts", [...accounts, { id: crypto.randomUUID().slice(0, 8), bank_name: "", account_name: "", account_number: "" }]);

  return (
    <div className="space-y-8">
      <MultiLangField label={t("payment_instructions")} value={draft.payment_instructions} onChange={(v) => set("payment_instructions", v)} multiline testPrefix="admin-settings-payment-instructions" />
      <div className="space-y-4">
        <Label className="text-sm font-bold">{t("bank_accounts")}</Label>
        {accounts.map((a, i) => (
          <div key={a.id || `bank-${i}`} className="grid gap-3 rounded-2xl border border-border p-4 md:grid-cols-[1fr_1fr_1fr_auto] md:items-end" data-testid={`admin-bank-editor-${i}`}>
            {FIELDS.map((k) => (
              <div key={k} className="space-y-1">
                <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t(k)}</span>
                <Input value={a[k] || ""} onChange={(e) => update(i, k, e.target.value)} data-testid={`admin-bank-${k}-${i}`} />
              </div>
            ))}
            <button type="button" onClick={() => set("bank_accounts", accounts.filter((_, idx) => idx !== i))} data-testid={`admin-bank-remove-${i}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-rose-300 text-rose-600 hover:bg-rose-50 dark:border-rose-800 dark:hover:bg-rose-950"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        <button type="button" onClick={add} data-testid="admin-bank-add-button" className="inline-flex items-center gap-2 rounded-full border border-dashed border-primary px-5 py-2.5 text-sm font-bold text-primary hover:bg-primary/5">
          <Plus className="h-4 w-4" />{t("add_bank")}
        </button>
      </div>
    </div>
  );
};

const CONTACT_FIELDS = [
  { k: "contact_email", label: "support_email", type: "email", ph: "support@example.com" },
  { k: "contact_phone", label: "contact_phone", type: "tel", ph: "+251 9XX XXX XXX" },
  { k: "telegram_link", label: "telegram_link", type: "text", ph: "@username / https://t.me/..." },
  { k: "whatsapp_number", label: "whatsapp_number", type: "tel", ph: "+251 9XX XXX XXX" },
];

export const ContactSettings = ({ draft, set }) => {
  const { t } = useLang();
  return (
    <div className="grid gap-5 md:grid-cols-2">
      {CONTACT_FIELDS.map((f) => (
        <div key={f.k} className="space-y-2">
          <Label className="text-sm font-bold">{t(f.label)}</Label>
          <Input type={f.type} value={draft[f.k] || ""} placeholder={f.ph} onChange={(e) => set(f.k, e.target.value)} data-testid={`admin-settings-${f.k.replace(/_/g, "-")}`} />
        </div>
      ))}
    </div>
  );
};
